import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'semantic-ui-css/semantic.min.css';
import { createStore, applyMiddleware, compose } from 'redux';
import reducers from './reducers';
import thunk from 'redux-thunk';

import 'mdbreact/dist/css/mdb.css';
//const rootElement = document.getElementById('root');

//// Create browser history to use in the Redux store
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//export const history = createBrowserHistory({ basename: baseUrl });

//// Get the application-wide store instance, prepopulating with state from the server where available.
//const initialState = window.initialReduxState;
//export const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
    reducers,
    composeEnhancers(applyMiddleware(thunk))
);

ReactDOM.render(
    <Provider store={store}>
            <App />
    </Provider>,
    rootElement);
                                                                                                                                                                                                                                                                                                                                                               
registerServiceWorker();